export class CustomAnalysisDTO {
    PK;
    SK;
    id;
    createdAt;
    updatedAt;
    type;
    tenantId;
    lookupGraphType;
    textGraphType;
    filterQuestions;
    analysisQuestions;
    startDate;
    endDate;
    userGroup;
    uniquePerUser;
    kmlFileId;
    kmlName;
    kmlDistanceOption;
    kmlDistanceOptionValue;
    kmlMarkers;
    kmlPolygons;
    kmlPolylines;

    constructor(analysis, tenant) {
        this.PK = `${analysis.tenantId}#CUSTOMANALYSIS`;
        this.SK = `ANALYSIS#`;
        this.id = analysis.id;
        this.type = "QNAIREANALYSIS";
        this.tenantId = analysis.tenantId;
        this.lookupGraphType = analysis.lookupGraphType;
        this.textGraphType = analysis.textGraphType;
        this.filterQuestions = analysis.filterQuestions ? analysis.filterQuestions : null;
        this.analysisQuestions = analysis.analysisQuestions ? analysis.analysisQuestions : null;
        this.startDate = analysis.startDate ? analysis.startDate : null;
        this.endDate = analysis.endDate ? analysis.endDate : null;
        this.userGroup = analysis.userGroup ? analysis.userGroup : null;
        this.uniquePerUser = analysis.uniquePerUser ? analysis.uniquePerUser : false;
        this.kmlFileId = analysis.kmlFileId ? analysis.kmlFileId : null;
        this.kmlName = analysis.kmlName ? analysis.kmlName : null;
        this.kmlMarkers = analysis.kmlMarkers ? analysis.kmlMarkers : [];
        this.kmlPolygons = analysis.kmlPolygons ? analysis.kmlPolygons : [];
        this.kmlPolylines = analysis.kmlPolylines ? analysis.kmlPolylines : [];
        this.kmlDistanceOption = analysis.kmlDistanceOption ? analysis.kmlDistanceOption : null;
        this.kmlDistanceOptionValue = analysis.kmlDistanceOptionValue ? analysis.kmlDistanceOptionValue : 1;
    }
}